import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import site from "./modules/site";
import admin from "./modules/admin";
import auth from "./modules/auth";
import outfitter from "./modules/outfitter";
import river from "./modules/river";
import riverSection from "./modules/riverSection";
import pricing from "./modules/pricing";
import queue from "@/store/modules/queue";
import displayGroups from "@/store/modules/displayGroups";
import search from "@/store/modules/search";
import order from "@/store/modules/order";
import report from "@/store/modules/report";
import slideshows from "@/store/modules/slideshows";
import publicRoutes from "@/store/modules/publicRoutes";
import photographer from "@/store/modules/photographer";
import misc from "./modules/misc";
import album from "./modules/album";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    user,
    site,
    admin,
    auth,
    outfitter,
    river,
    riverSection,
    pricing,
    queue,
    displayGroups,
    search,
    order,
    report,
    slideshows,
    publicRoutes,
    photographer,
    misc,
    album,
  },
  strict: debug,
});
